function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { OptionState, SelectAllEnum, useSelect } from '../../../hooks/select';
import { useUpdate } from '@bydesign-ui/hooks';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { ListItem } from '../../util/ListItem';
export function SelectAll(props) {
  var _props$showAll = props.showAll,
      showAll = _props$showAll === void 0 ? false : _props$showAll;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      fillback = _useState2[0],
      setFillBack = _useState2[1];

  var select = useSelect();
  var locale = useLocale('select.select-all');
  var update = useUpdate();
  var extraProps = select.getExtraProps();
  var size = extraProps.size || 'md';
  var cls = usePrefixCls('select-option', {
    selected: select.getSelectAll(),
    all: true,
    'fill-back': fillback
  });
  var handleCheckboxChange = useCallback(function (checked) {
    select.setSelectAll(checked ? OptionState.SELECTED : OptionState.UNSELECTED);
  }, [select]);
  var handleItemClick = useCallback(function () {
    var selected = select.getSelectAll();
    select.setSelectAll(selected ? OptionState.UNSELECTED : OptionState.SELECTED);
  }, [select]);
  useEffect(function () {
    var handleBackFillUpdate = function handleBackFillUpdate(backFillId) {
      setFillBack(function (val) {
        if (backFillId === SelectAllEnum.ALL && !val) {
          return true;
        }

        if (backFillId !== SelectAllEnum.ALL && val) {
          return false;
        }

        return val;
      });
    };

    select.addListener('update-select-all-state', update);
    select.addListener('search-query', update);
    select.addListener('back-fill-update', handleBackFillUpdate);
    return function () {
      select.removeListener('update-select-all-state', update);
      select.removeListener('search-query', update);
      select.removeListener('back-fill-update', handleBackFillUpdate);
    };
  }, []);

  if (!select.multiple || !showAll || select.searchQuery) {
    return null;
  }

  return React.createElement(ListItem, {
    prefixCls: "select-option",
    checkable: extraProps.checkType === 'checkbox',
    disabled: select.getSelectAllDisabled(),
    readonly: select.getSelectAllReadonly(),
    state: select.getSelectAll() ? OptionState.SELECTED : OptionState.UNSELECTED,
    onCheckboxChange: handleCheckboxChange,
    className: cls,
    onClick: handleItemClick,
    size: size
  }, locale);
}